import React, { useState } from 'react';
import { authHelpers } from '../global/supabase';
import '../global/styles.css';
import NTlogo from '../assets/images/NTlogo.jpeg';
import MayoLogo from '../assets/images/Mayo.png';

function Welcome({ onComplete }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Welcome",
      subtitle: "NarcoticTrack - the most efficient and safe way to inventory controlled substances in EMS.",
      showLogos: true
    },
    {
      title: "Let's Get Started",
      subtitle: "Sign in to your account or create a new one to begin tracking your controlled substance inventory.",
      showLogos: false
    }
  ];

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      // Mark onboarding as complete and proceed to login
      authHelpers.markOnboardingComplete();
      onComplete();
    }
  };

  return (
    <div className="container">
      <div className="content">
        {slides[currentSlide].showLogos && (
          <div className="logo-bg">
            <img src={NTlogo} alt="NarcoticTrack" className="logo-nt" />
          </div>
        )}
        
        <div className="card card-center">
          {slides[currentSlide].showLogos && (
            <div className="logo-container">
              <img src={MayoLogo} alt="Mayo Clinic" className="logo-location" />
            </div>
          )}
          
          <h1 className="title">{slides[currentSlide].title}</h1>
          <p className="subtitle">{slides[currentSlide].subtitle}</p>
          
          <button onClick={nextSlide} className="btn btn-primary btn-rounded">
            {currentSlide < slides.length - 1 ? 'Continue' : 'Log In'}
          </button>
        </div>
      </div>
      
      <footer className="footer">
        <p className="text-small">NarcoticTrack © 2025 NarcoticTrack Inventory System, LLC</p>
      </footer>
    </div>
  );
}

export default Welcome;